// ----------
// auth-reg-and-mqtt.js
// Haudi Registration/MQTT Password Calcurator
//
// 2023/07/06
// Created by Kazunori Asada
// Modified by Shotaro Ito
// Copyright 2022, Haudi Inc.
//

import * as exportFunction from "./Encryption";

// うるう秒を無視しているので、30分ごとの切れ目が毎時0分と30分ぴったりにはならない。20秒程度ずれる。
const kUserRegPasswordSalt = "NakameguroHaudi";
const kMqttCloudBrokerPasswordSalt = "MeguroAmazon";
const kDoorConMqttPasswordSalt = "DoorCon1317";

const kPasswordTimeLimit = 30 * 60 * 1000; // 30分

let result; //ここで宣言しておかないと'result' is not definedが出る

export function uuidToRegiPassword(uuid: string) {
  const date = new Date();
  const dateTime = date.getTime();
  const modLimitMin = dateTime % kPasswordTimeLimit;
  let baseTime = dateTime - modLimitMin;
  if (modLimitMin >= kPasswordTimeLimit / 2) baseTime += kPasswordTimeLimit;
  return exportFunction.md5Hash(
    uuid + kUserRegPasswordSalt + baseTime.toString(),
  );
}

export function checkUuidToRegiPassword(uuid: string, password: any) {
  const date = new Date();
  const dateTime = date.getTime();
  const modLimitMin = dateTime % kPasswordTimeLimit;
  let baseTime = dateTime - modLimitMin;
  if (modLimitMin >= kPasswordTimeLimit / 2) baseTime += kPasswordTimeLimit;
  if (baseTime < dateTime)
    result =
      exportFunction.md5Hash(
        uuid + kUserRegPasswordSalt + baseTime.toString(),
      ) == password ||
      exportFunction.md5Hash(
        uuid +
          kUserRegPasswordSalt +
          (baseTime + kPasswordTimeLimit).toString(),
      ) == password;
  else
    result =
      exportFunction.md5Hash(
        uuid + kUserRegPasswordSalt + baseTime.toString(),
      ) == password ||
      exportFunction.md5Hash(
        uuid +
          kUserRegPasswordSalt +
          (baseTime - kPasswordTimeLimit).toString(),
      ) == password;
  return result;
}

export function uuidToMqttPassword(uuid: string) {
  const date = new Date();
  const dateTime = date.getTime();
  const modLimitMin = dateTime % kPasswordTimeLimit;
  let baseTime = dateTime - modLimitMin;
  if (modLimitMin >= kPasswordTimeLimit / 2) baseTime += kPasswordTimeLimit;
  // console.error("uuidToMqttPassword - dateTime: " + dateTime + ", modLimitMin: " + modLimitMin + ", baseTime: " + baseTime);
  // console.error("uuidToMqttPassword - seed: " + uuid + kMqttCloudBrokerPasswordSalt + baseTime.toString());
  // console.error("uuidToMqttPassword - hash: " + exportFunction.md5Hash(uuid + kMqttCloudBrokerPasswordSalt + baseTime.toString()));
  return exportFunction.md5Hash(
    uuid + kMqttCloudBrokerPasswordSalt + baseTime.toString(),
  );
}

export function checkUuidToMqttPassword(uuid: string, password: any) {
  const date = new Date();
  const dateTime = date.getTime();
  const modLimitMin = dateTime % kPasswordTimeLimit;
  let baseTime = dateTime - modLimitMin;
  if (modLimitMin >= kPasswordTimeLimit / 2) baseTime += kPasswordTimeLimit;
  if (baseTime < dateTime)
    result =
      exportFunction.md5Hash(
        uuid + kMqttCloudBrokerPasswordSalt + baseTime.toString(),
      ) == password ||
      exportFunction.md5Hash(
        uuid +
          kMqttCloudBrokerPasswordSalt +
          (baseTime + kPasswordTimeLimit).toString(),
      ) == password;
  else
    result =
      exportFunction.md5Hash(
        uuid + kMqttCloudBrokerPasswordSalt + baseTime.toString(),
      ) == password ||
      exportFunction.md5Hash(
        uuid +
          kMqttCloudBrokerPasswordSalt +
          (baseTime - kPasswordTimeLimit).toString(),
      ) == password;
  return result;
}

export function uuidToMqttPasswordDC(uuid: string) {
  const date = new Date();
  const dateTime = date.getTime();
  const modLimitMin = dateTime % kPasswordTimeLimit;
  let baseTime = dateTime - modLimitMin;
  if (modLimitMin >= kPasswordTimeLimit / 2) baseTime += kPasswordTimeLimit;
  // console.error("uuidToMqttPassword - dateTime: " + dateTime + ", modLimitMin: " + modLimitMin + ", baseTime: " + baseTime);
  // console.error("uuidToMqttPassword - seed: " + uuid + kMqttCloudBrokerPasswordSalt + baseTime.toString());
  // console.error("uuidToMqttPassword - hash: " + exportFunction.md5Hash(uuid + kMqttCloudBrokerPasswordSalt + baseTime.toString()));
  return exportFunction.md5Hash(
    uuid + kDoorConMqttPasswordSalt + baseTime.toString(),
  );
}

export function checkUuidToMqttPasswordDC(uuid: string, password: any) {
  const date = new Date();
  const dateTime = date.getTime();
  const modLimitMin = dateTime % kPasswordTimeLimit;
  let baseTime = dateTime - modLimitMin;
  if (modLimitMin >= kPasswordTimeLimit / 2) baseTime += kPasswordTimeLimit;
  if (baseTime < dateTime)
    result =
      exportFunction.md5Hash(
        uuid + kDoorConMqttPasswordSalt + baseTime.toString(),
      ) == password ||
      exportFunction.md5Hash(
        uuid +
          kDoorConMqttPasswordSalt +
          (baseTime + kPasswordTimeLimit).toString(),
      ) == password;
  else
    result =
      exportFunction.md5Hash(
        uuid + kDoorConMqttPasswordSalt + baseTime.toString(),
      ) == password ||
      exportFunction.md5Hash(
        uuid +
          kDoorConMqttPasswordSalt +
          (baseTime - kPasswordTimeLimit).toString(),
      ) == password;
  return result;
}

export function uuidToAPIPasswordDC(uuid: string) {
  const date = new Date();
  const dateTime = date.getTime();
  const modLimitMin = dateTime % kPasswordTimeLimit;
  let baseTime = dateTime - modLimitMin;
  if (modLimitMin >= kPasswordTimeLimit / 2) baseTime += kPasswordTimeLimit;
  // console.error("uuidToMqttPassword - dateTime: " + dateTime + ", modLimitMin: " + modLimitMin + ", baseTime: " + baseTime);
  // console.error("uuidToMqttPassword - seed: " + uuid + kMqttCloudBrokerPasswordSalt + baseTime.toString());
  // console.error("uuidToMqttPassword - hash: " + exportFunction.md5Hash(uuid + kMqttCloudBrokerPasswordSalt + baseTime.toString()));
  return exportFunction.md5Hash(
    uuid + kDoorConMqttPasswordSalt + baseTime.toString(),
  );
}

export function checkUuidToAPIPasswordDC(uuid: string, password: any) {
  const date = new Date();
  const dateTime = date.getTime();
  const modLimitMin = dateTime % kPasswordTimeLimit;
  let baseTime = dateTime - modLimitMin;
  if (modLimitMin >= kPasswordTimeLimit / 2) baseTime += kPasswordTimeLimit;
  if (baseTime < dateTime)
    result =
      exportFunction.md5Hash(
        uuid + kDoorConMqttPasswordSalt + baseTime.toString(),
      ) == password ||
      exportFunction.md5Hash(
        uuid +
          kDoorConMqttPasswordSalt +
          (baseTime + kPasswordTimeLimit).toString(),
      ) == password;
  else
    result =
      exportFunction.md5Hash(
        uuid + kDoorConMqttPasswordSalt + baseTime.toString(),
      ) == password ||
      exportFunction.md5Hash(
        uuid +
          kDoorConMqttPasswordSalt +
          (baseTime - kPasswordTimeLimit).toString(),
      ) == password;
  return result;
}
